import { logger, SeverityLevel } from "@mwt/web-js-telemetry";

export const trackComponentErrorTrace = <ErrorTraceType extends Error>(
  { message, stack }: ErrorTraceType,
  info: React.ErrorInfo
): void => {
  // Log error trace
  logger.error(message, SeverityLevel.Error, {
    componentStack: info.componentStack,
    stack: stack ?? "",
  });
};
